import React, {Component} from 'react'
import Tone from 'tone'
import Header from '../Header/Header'
import InstrumentContainer from '../Instrument/InstrumentContainer'
import PunchContainer from '../Punch/PunchContainer'
import ScratchContainer from '../Scratch/ScratchContainer'
import GoodBeatContainer from '../GoodBeat/GoodBeatContainer'
import './Sequencer.css'

const transport = Tone.Transport
Tone.Transport.bpm.value = 110
transport.setLoopPoints(0, '2m')
transport.loop = true

class Sequencer extends Component {
  constructor() {
    super() 
    this.state = {
      player: transport,
      playerPlaying: false,
      playerShouldStop: false,
      playerShouldStart: false,
      goodBeatShouldStop: false,
      goodBeatPlaying: false
    }
  }

  handlePlayerStop() {
    this.setState({
      player: this.state.player.stop(),
      goodBeatPlaying: true,
      playerShouldStop: true
    })
  }

  handlePlayerToggle() {
    this.setState({
      player: this.state.player.toggle()
    })
  }

  confirmPlayerStop() {
    this.setState({
      playerShouldStop: false
    })
  }

  handlePlayerStart() {
    this.setState({
      playerShouldStart: true
    })
  }

  goodBeatToStop() {
    this.setState({
      goodBeatShouldStop: true
    })
  }

  handleGoodBeatStop() {
    this.setState({
      goodBeatPlaying: false,
      goodBeatShouldStop: false,
      playerShouldStart: true
    })
  }

  render() {
    return (
      <div className='sequencer'>
        <div className="seqRow seqTop">
          <Header />
        </div>
        <div className="seqRow seqMain">
          <div className='seqLeft'>
            <InstrumentContainer 
              player={this.state.player}
              goodBeatPlaying={this.state.goodBeatPlaying}
              playerShouldStop={this.state.playerShouldStop}
              confirmPlayerStop={() => this.confirmPlayerStop()}
              goodBeatToStop={() => this.goodBeatToStop()}
              handlePlayerToggle={() => this.handlePlayerToggle()}
            />
          </div>
          <div className='seqRight'>
            <PunchContainer />
            <ScratchContainer />
          </div>
        </div>
        <div className='seqRow seqBottom'>
          <GoodBeatContainer 
            player={this.state.player}
            goodBeatPlaying={this.state.goodBeatPlaying}
            goodBeatShouldStop={this.state.goodBeatShouldStop}
            handlePlayerStop={() => this.handlePlayerStop()}
            handleGoodBeatStart={() => this.handleGoodBeatStart()}
            handleGoodBeatStop={() => this.handleGoodBeatStop()}
          />
        </div>
      </div>
    )
  }
}

export default Sequencer


// WEBPACK FOOTER //
// ./src/Sequencer/Sequencer.js